module.exports = __webpack_public_path__ + "img/support_e10.99dc2fd7.png";